/**
 * Manager P&L: show "Quoted Expenses" only when the logged-in manager owns the
 * tracking project and the linked old project's manager is the same person.
 * Otherwise (no oldprojectid, different old manager, or no tracking row) show
 * actual expenses only during the project-tracking phase.
 */
export function shouldShowManagerQuotedExpense({
  quotationIdOrName,
  projects,
  loggedManagerId,
  email,
  getProjQuotationId,
}) {
  const loggedId = String(loggedManagerId || "").trim();
  if (!loggedId) return true;

  const resolveQId = getProjQuotationId || ((p) => p?.quotationId ?? p?.QuotationId ?? p?.ProjectName);
  const needle = String(quotationIdOrName ?? "").trim();

  const trackingProjects = (projects || []).filter(
    (p) =>
      p.isProjecttracking === true &&
      String(p.managerid || p.managerId || "") === loggedId &&
      (String(resolveQId(p)) === needle ||
        String(p.ProjectName || "").trim() === needle) &&
      (!email || p.AssignedManagerEmail?.includes(email))
  );

  if (!trackingProjects.length) {
    return true;
  }

  return trackingProjects.some((trackingProject) => {
    const oldProjectId =
      trackingProject.oldprojectid || trackingProject.oldProjectId;
    if (!oldProjectId) return false;

    const oldProject = (projects || []).find(
      (p) => String(p._id) === String(oldProjectId)
    );
    if (!oldProject) return false;

    const oldManagerId = String(
      oldProject.managerid || oldProject.managerId || ""
    ).trim();
    return oldManagerId === loggedId;
  });
}
